<template>
  <div>
    <!-- {{item}}/ -->
    <br />
    <div class="div_item_flex" v-if="item.Total_power_consumption">
      <div
        style="display: grid; align-items: center"
        class="width-div margin-ri carddiv"
      >
        <h1 class="mt-2 p-3" style="font-weight: 600" align="center">
          Total power consumption
        </h1>
        <div class="div_item_flex">
          <div style="width: 50%">
            <img
              style="width: 100%"
              src="@/assets/images/gif Yamaha/fan.gif"
              alt=""
            />
          </div>
          <div style="width: 50%">
            <ul class="list-none padding-div1-text">
              <li class="mb-3">
                <h5>Total Power Volume</h5>
              </li>

              <li style="display: flex; align-items: flex-end" class="mb-3">
                <h1 style="font-weight: 600">
                  {{ item.Total_power_consumption.Power_Volume }}
                </h1>
                <h5 class="ml-3">kWh</h5>
              </li>
              <br />
              <li class="mb-3">
                <h5>Power Factor</h5>
              </li>

              <li style="display: flex; align-items: flex-end" class="mb-3">
                <h1 style="font-weight: 600">
                  {{ item.Total_power_consumption.Power_Factor }}
                </h1>
                <h5 class="ml-3">PF</h5>
              </li>
              <br />

              <li class="mb-3">
                <h6>
                  Yearly Volume
                  <b class="ml-1" style="font-weight: 600">{{
                    item.Total_power_consumption.Yearly_Power_Volume
                  }}</b>
                  <span class="ml-1">kWh</span>
                </h6>
              </li>
              <li class="mb-3">
                <h6>
                  Monthy Volume
                  <b class="ml-1" style="font-weight: 600">{{
                    item.Total_power_consumption.Monthy_Power_Volume
                  }}</b>
                  <span class="ml-1">kWh</span>
                </h6>
              </li>
              <li class="mb-3">
                <h6>
                  Daily Volume
                  <b class="ml-1" style="font-weight: 600">{{
                    item.Total_power_consumption.Daily_Power_Volume
                  }}</b>
                  <span class="ml-1">kWh</span>
                </h6>
              </li>
              
            <li class="mb-3">
              <h5>
                Daily
                <b class="ml-1" style="font-weight: 600">{{
                   item.Total_power_consumption.power_max == undefined
                    ? "-"
                    :  item.Total_power_consumption.power_max
                }}</b>
                <span class="ml-2">Peak kw</span>
              </h5>
            </li>
            </ul>
          </div>
        </div>
      </div>

      <div
        style="
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        "
        class="width-div-graph-r p-10"
      >
        <div class="div_item_flex heigth-50">
          <div class="carddiv width-50 mr-20 p-2">
            <chart
              :text="'Power Volume'"
              :unit="'kWh'"
              colorgraph="#EF9BD8"
              :heightgrapg="130"
              :datasets3="item.Power_Volume"
            />
          </div>
          <div class="carddiv width-50 p-2">
            <chart
              :text="'Power Factor'"
              :unit="'PF'"
              colorgraph="#b85bff"
              :heightgrapg="130"
              :datasets3="item.Power_Factor"
            />
          </div>
        </div>
        <br />
        <div class="carddiv heigth-50 p-2">
          <chartbar
            :text="'Graph of Power Consumption'"
            :colorgraph="borderColorP"
            :heightgrapg="160"
            :datasets3="item.Graph_of_Power_Consumption"
          />
        </div>
      </div>
    </div>
    <br />
    <div class="div_item_flex">
      <div class="width-div-2 margin-ri carddiv" v-if="item.Electric_Potential">
        <h2 class="mt-2 p-3" style="font-weight: 600" align="center">
          Electric Potential
        </h2>
        <br />
        <div v-for="i in 3" :key="i" style="display: flex; align-items: center">
          <div style="width: 100%">
            <ul class="list-none" align="center">
              <li>
                <h4 :class="'textlist2 gradient' + i">Data Phase {{ i }}</h4>
              </li>
              <li class="mt-3">
                <h4>
                  <b style="font-weight: 600; color: #ecb314">Volt</b>
                  <b class="ml-2 mr-2" style="font-weight: 600">
                    {{ item.Electric_Potential["Data_Phase_" + i].Volt }}</b
                  >V
                </h4>
              </li>

              <li class="mt-3">
                <h4>
                  <b style="font-weight: 600; color: #866ed6">Amps</b>
                  <b class="ml-2 mr-2" style="font-weight: 600">
                    {{ item.Electric_Potential["Data_Phase_" + i].Amps }}</b
                  >I
                </h4>
              </li>
            </ul>
          </div>
        </div>
        <vs-row>
          <vs-spacer />
          <ul class="list-none mt-1 mr-3">
            <li>
              <a>Date : {{ item.timestamp.split(" ")[0] }}</a>
            </li>
            <li>
              <a>Time : {{ item.timestamp.split(" ")[1] }}</a>
            </li>
          </ul>
        </vs-row>
      </div>
      <div class="width-div-graph-r-2 carddiv">
        <h2 class="mt-2 p-3" style="font-weight: 600">
          Electric Potential Graph
        </h2>
        <!-- <chart-stock
          :dataA="dataA"
          :dataB="dataB"
          :dataC="dataC"
          v-if="dataC.length > 0"
        /> -->
        <StockChart :chart="StockChartCom" />
      </div>
    </div>
  </div>
</template>

<script>
import chart from "./chart.vue";
import unaxischart from "./chartunaxis.vue";
import chartbar from "./chartbar.vue";
// import ChartStock from "./ChartStock.vue";

import StockChart from "@/components/HighChart/StockChart.vue";
import LineChart from "@/components/ChartJs/LineChart.vue";
export default {
  components: {
    chart,
    // ChartStock,
    unaxischart,
    chartbar,
    LineChart,
    StockChart,
  },
  props: ["item"],
  data() {
    return {
      optionsChart: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: false,
          title: {},
          position: "bottom",
        },
        scales: {
          yAxes: [
            {
              display: false,
            },
          ],
          xAxes: [
            {
              display: false,
            },
          ],
        },
      },
      options_select: [
        { text: "Day", value: 1 },
        { text: "Month", value: 2 },
        { text: "Year", value: 3 },
      ],
      select_scater: 1,
      nameid: null,
      dataB: [],
      dataC: [],
      dataA: [],
      infoNew: {
        id: "ไลน์เครื่องจักร/แผนก",
        mac: "เลขรหัสประจำเครื่อง",
        machine_name: "ชื่อเครื่องจักร",
        model: "ยี่ห้อเครื่องจักร",
        series: "รุ่นเครื่องจักร",
        name: "ผู้รับผิดชอบ",
        phone: "Tel.",
      },
      label: {
        id: "ไลน์เครื่องจักร/แผนก",
        mac: "เลขรหัสประจำเครื่อง",
        machine_name: "ชื่อเครื่องจักร",
        model: "ยี่ห้อเครื่องจักร",
        series: "รุ่นเครื่องจักร",
        name: "ผู้รับผิดชอบ",
        phone: "Tel.",
      },
      optionChart: {
        chart: {
          backgroundColor: "transparent",
        },
        // rangeSelector: {
        //   selected: 1,
        // },
        rangeSelector: {
          buttons: [
            {
              type: "hour",
              count: 3,
              text: "3h",
            },
            {
              type: "hour",
              count: 6,
              text: "6h",
            },
            {
              type: "hour",
              count: 12,
              text: "12h",
            },
            {
              type: "day",
              count: 1,
              text: "1D",
            },
            {
              type: "all",
              count: 1,
              text: "All",
            },
          ],
          selected: 1,
          // inputEnabled: false
        },
        colors: ["#cc7400", "#00cc7e", "#da2acb"],
        title: {
          // text: "Vibration Sensor Graph",
          align: "left",
          style: {
            color: "var(--text-color-2)",
            fontSize: "18px",
            "font-weight": "900",
          },
        },

        series: [],
      },
      delayStockChart: 0,
    };
  },
  mounted() {
    console.log(this.item);
 
    // console.log(new Date().getTime());
  },
  methods: {},
  computed: {
    chartDataCom() {
      let data = [];
      for (const key in this.item.Electric_Potential) {
        // console.log(key);
        let ob = this.item.Electric_Potential[key];
        let volt = [];
        let amps = [];
        let labels = [];
        ob.data.reverse();
        for (let index = 0; index < ob.data.length; index++) {
          const el = ob.data[index];
          // console.log(el.time);
          volt.push(el.volt);
          amps.push(el.amps);
          labels.push(el.time);
        }
        let datasets = [
          {
            data: volt,
            label: "Volt ( V )",
            pointBorderWidth: 0,
            borderWidth: 5,
            borderColor: "#ecb314",
            backgroundColor: "#0000",
          },
          {
            data: amps,
            label: "Amps ( I )",
            pointBorderWidth: 0,
            borderWidth: 5,
            borderColor: "#866ed6",
            backgroundColor: "#0000",
          },
        ];
        data.push({
          datasets: datasets,
          labels: labels,
        });
      }
      this.delayStockChart = 1;

      return data;
    },
    StockChartCom() {
      this.optionChart.series = [
        {
          name: "Phase 1",
          data: this.item.Electric_Potential_Graph.Phase_1,
          tooltip: {
            valueDecimals: 2,
          },
        },
        {
          name: "Phase 2",
          data: this.item.Electric_Potential_Graph.Phase_2,
          tooltip: {
            valueDecimals: 2,
          },
        },
        {
          name: "Phase 3",
          data: this.item.Electric_Potential_Graph.Phase_3,
          tooltip: {
            valueDecimals: 2,
          },
        },
      ];
      return this.optionChart;
    },
  },
};
</script>

<style lang="scss" scoped>
.width-div {
  width: calc(100% / 3);
}
.width-div-2 {
  width: calc(100% / 4);
}
.width-div-graph-r-2 {
  width: calc(100% - (100% / 4));
}
.width-div-graph-r {
  width: calc(100% - (100% / 3));
}
.width-50 {
  width: 50%;
}
.heigth-50 {
  height: 50%;
}
.textlist2 {
  /* background: linear-gradient(90deg, #00C9FF 0%, #92FE9D 100%); */
  border-radius: 20px;
  padding: 5px;
  font-weight: 600;
  margin: 0 20%;
}
.gradient1 {
  background: linear-gradient(
    90deg,
    rgb(247, 141, 84) 0%,
    rgb(245, 185, 82) 100%
  );
  /* font-weight: 500; */
}
.gradient2 {
  background: linear-gradient(90deg, #77d8f3 0%, #92fe9d 100%);
  /* font-weight: 500; */
}
.gradient3 {
  background: linear-gradient(90deg, #fa7ba5 0%, #f3c86b 100%);
  /* font-weight: 500; */
}
.select-date {
  display: flex;
  align-items: center;
  color: #808080;
  flex-wrap: wrap;
  .date-range {
    display: flex;
    align-items: center;
    gap: 5px;
    border: 1px #808080 solid;
    border-radius: 30px;
    padding: 8px;
    background-color: #fff;
  }
}
.div-space {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.div-graph {
  width: 50%;
  height: 100%;
}
.div_item_flex {
  display: flex;
}
.padding-10 {
  padding: 10px;
}
// .padding-20 {
//   padding: 20px;
// }
.list-none {
  list-style: none;
}
.div-row {
  display: flex;
  width: 100%;
}
.div-row-grapg {
  display: flex;
  width: 100%;
  height: 50%;
}
.widthdiv1 {
  width: 28%;
  margin-right: 20px;
}
.widthdiv1-1 {
  width: 28%;
  // margin-right: 20px;
}
.widthdiv1-2 {
  width: 28%;
  // margin-right: 20px;
}
.widthdiv {
  width: 72%;
}
.width_item2 {
  width: 35%;
}
.width_div3 {
  margin-left: 20px;
  // display: grid;
}
.mr-20 {
  margin-right: 20px;
}
.margin-ri {
  margin-right: 20px;
}
.carddiv {
  height: auto;
  background: var(--background-color-sidebar);
  border-radius: 20px;
  display: block;
  //   -webkit-box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.1);
  //   -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.li-div2 {
  display: flex;
  align-items: center;
}
.div2st {
  position: relative;
  width: 30%;
}
.div3st1 {
  position: relative;
  width: 40%;
}
.div3st2 {
  position: relative;
  width: 70%;
}
.item2_flex {
  display: flex;
  white-space: nowrap;
}
.item2_div1 {
  font-size: 0.8rem;
}
.item2_div2 {
  /* margin-top: 10px;
  margin-right: 10px; */
  /* float: right; */
  display: flex;
  justify-content: flex-end;
  // justify-content: center;
  font-size: 0.1rem;
}
.text-temp2 {
  font-size: 2.5rem;
}
.img-div2 {
  width: 70%;
  margin-top: 15px;
  margin-left: 15px;
}
.img-div3 {
  width: 100%;
  margin-top: 15px;
  margin-left: 15px;
}
.text-div2 {
  position: absolute;
  top: 10px;
}
.text_b {
  font-weight: 600;
}
.text_temp_small {
  font-size: 1.2rem;
  font-weight: 600;
}
.container-fluid {
  display: flex;
  justify-content: center;
}
// .header-top1 {
// margin-bottom: 5em;
// margin: 20px;
// }
.header-top2 {
  margin-top: 3em;
}
.div_item_flex3_1_1 {
  width: 50%;
}
.div_item_flex3_1_2 {
  // width: 100%;
  margin-left: 20px;
  height: 50%;
}
.padding-div1-text {
  padding: 20px;
}
.font-color-black {
  color: #4d4f5c;
}
@media only screen and (max-width: 700px) {
  .margin-ri {
    margin-right: 0;
    margin-bottom: 20px;
  }
  .div-row {
    flex-wrap: wrap;
  }
  .div_item_flex {
    flex-wrap: wrap;
  }
  .widthdiv {
    width: 100%;
  }
  .width-div,
  .width-div-2 {
    width: 100%;
  }
  .width-div-graph-r,
  .width-div-graph-r-2 {
    width: 100%;
  }
  .widthdiv1 {
    width: 100%;
    margin-right: 0;
    margin-bottom: 20px;
  }
  .mr-20 {
    margin-right: 0;
    margin-bottom: 20px;
  }
  .header-top1 {
    margin-bottom: 2em;
    margin-top: 1em;
  }
  .header-top2 {
    margin-top: 0;
  }
  .width_div3 {
    margin-left: 0;
  }
  .div_item_flex3_1_1 {
    width: 100%;
  }
  .div_item_flex3_1_2 {
    width: 100%;
    margin-left: 0;
    margin-top: 20px;
    height: auto;
  }
  .div-graph {
    width: 100%;
  }
  .div-space {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .width-50 {
    width: 100%;
  }
  .heigth-50 {
    height: 100%;
  }
}
</style>